// src/data/programData.js
export const PROGRAM_DATA = {
  introduction: {
    title: 'Introduction',
    description: 'Learn about the ACL Care program',
    videoUrl: 'https://www.youtube.com/embed/ebnVwiJq6_I',
    content: `We're so glad you decided to use our Return to Play protocol!  Click above to get introduced to the platform and how it works!`,
    whyImportant: {
      title: 'Why is this so important?',
      videoUrl: 'https://www.youtube.com/embed/kzdWlk8wi9A',
    }
  },
  
  phases: {
    phase_1: {
      id: 1,
      key: 'phase_1',
      title: 'Phase I',
      subtitle: 'Foundation',
      description: 'Welcome to Phase 1 of our Return to Play protocol! Phase 1 will be 3 weeks long.',
      videoUrl: 'https://www.youtube.com/embed/TXaqFFogXlk',
      warmupIntroUrl: 'https://youtu.be/ZGao2VvEBOs',
      color: 'blue',
      targetCompletions: { session_1: 3, session_2: 3, optional: 3 },
    },
    phase_2: {
      id: 2,
      key: 'phase_2',
      title: 'Phase II',
      subtitle: 'Strength',
      description: 'Welcome to Phase 2 of our Return to Play protocol! Phase 2 will be 3 weeks long.',
      videoUrl: 'https://www.youtube.com/embed/XD__-fjenkc',
      warmupIntroUrl: 'https://youtu.be/33avVLYMWqQ',
      color: 'green',
      targetCompletions: { session_1: 3, session_2: 3, optional: 3 },
    },
    phase_3: {
      id: 3,
      key: 'phase_3',
      title: 'Phase III',
      subtitle: 'Power',
      description: 'Welcome to Phase 3 of our Return to Play protocol! Phase 3 will be 4 weeks long.',
      videoUrl: 'https://www.youtube.com/embed/g5eK_3uv_z0',
      warmupIntroUrl: 'https://youtu.be/V1LBWPyxf14',
      color: 'purple',
      targetCompletions: { session_1: 4, session_2: 4, optional: 4 },
      hasReturnToRun: true,
    },
    phase_4: {
      id: 4,
      key: 'phase_4',
      title: 'Phase IV',
      subtitle: 'Return to Sport',
      description: 'Welcome to Phase 4 of our Return to Play protocol! Phase 4 will be 4 weeks long.',
      videoUrl: 'https://www.youtube.com/embed/aP7MT0rsBlk',
      warmupIntroUrl: 'https://youtu.be/f1WqEt2maoA',
      color: 'orange',
      targetCompletions: { session_1: 4, session_2: 4, optional: 4 },
    },
  },

  exerciseBank: {
    title: 'Exercise Bank',
    description: 'Browse all exercises',
  }
};

// Helper to get phase by ID or key
export function getPhaseData(phaseIdOrKey) {
  if (typeof phaseIdOrKey === 'number') {
    return Object.values(PROGRAM_DATA.phases).find(p => p.id === phaseIdOrKey);
  }
  return PROGRAM_DATA.phases[phaseIdOrKey];
}